import React from 'react';
import { TemplateContainer, TemplateTabContent } from './Template.styled';
import MetricsTable from './MetricsTable/MetricsTable';
import Notes from './Notes/Notes';
import Chart from './Chart/Chart';
import LockedComparativeEstimates from './ComparativeEstimates/LockedComparativeEstimates';
import LockedInsights from './Insights/LockedInsights';
import { connect } from 'react-redux';
import { PrimaryTabs } from '@emarketer/componentlibrary';
import PremiumTag from '../PremiumTag/PremiumTag';
import config from '../../config';

interface ITemplateView {
  isLoaded: boolean;
  hasComparativeEstimates: boolean;
  forecastIsPremium: boolean;
  onDoesMyCompanySubscribe: any;
}

function mapStateToProps(state) {
  return {
    hasComparativeEstimates:
      state.template.comparativeEstimates !== undefined && state.template.comparativeEstimates.length > 0,
    isLoaded: state.template.loaded,
    forecastIsPremium: state.premium.forecastIsPremium,
  };
}

export class Template extends React.Component<ITemplateView, {}> {
  public render() {
    const { hasComparativeEstimates, forecastIsPremium, onDoesMyCompanySubscribe } = this.props;

    const trackTab = (tabKey) => {
      window.iiAna('track', `Forecasts-Tab`, {
        tab: tabKey,
      });
    };

    const displayPremiumFeatures = config.enableNonPremiumFeatures && forecastIsPremium;

    return (
      <TemplateContainer>
        <Chart
          onDoesMyCompanySubscribe={() => onDoesMyCompanySubscribe()}
          displayPremiumFeatures={displayPremiumFeatures}
        />
        <PrimaryTabs
          tabs={[
            {
              tabKey: 'Source & Notes',
              content: (
                <TemplateTabContent>
                  <Notes />
                </TemplateTabContent>
              ),
            },
            {
              tabKey: 'Data Table',
              content: (
                <TemplateTabContent>
                  <MetricsTable />
                </TemplateTabContent>
              ),
            },
            ...(displayPremiumFeatures && hasComparativeEstimates
              ? [
                  {
                    tabKey: 'Third Party Data',
                    content: (
                      <TemplateTabContent>
                        <LockedComparativeEstimates />
                      </TemplateTabContent>
                    ),
                    tag: <PremiumTag />,
                  },
                ]
              : []),
            ...(displayPremiumFeatures
              ? [
                  {
                    tabKey: 'Forecast Insights',
                    content: (
                      <TemplateTabContent>
                        <LockedInsights />
                      </TemplateTabContent>
                    ),
                    tag: <PremiumTag />,
                  },
                ]
              : []),
          ]}
          callback={trackTab}
        />
      </TemplateContainer>
    );
  }
}

export default connect(mapStateToProps, null)(Template);
